export const i18n = {
  defaultLocale: 'en',
  locales: ['en', 'it', 'de', 'fr'],
} as const;

// TODO: no need for this export type anymore (because of globals.d.ts), but also needs to remove all it's imports
export type Locale = (typeof i18n)['locales'][number];
